import { render, staticRenderFns } from "./detailDrDistindecator.vue?vue&type=template&id=07772e95&scoped=true"
import script from "./detailDrDistindecator.vue?vue&type=script&lang=js"
export * from "./detailDrDistindecator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07772e95",
  null
  
)

export default component.exports